import type { DataTableColumn } from '@/components/custom/erp';
import type { LyDoTangGiamTSCD } from '@/types/schemas';

export const getDataTableColumns = (): DataTableColumn<LyDoTangGiamTSCD>[] => [
  {
    field: 'loai_tg_ts',
    headerName: 'Loại tăng giảm',
    width: 150,
    renderCell: params => {
      const value = params.row.loai_tg_ts as unknown;
      return value == 1 ? '1. Tăng' : '2. Giảm';
    }
  },
  {
    field: 'ma_tg_ts',
    headerName: 'Mã tăng giảm',
    width: 150
  },
  {
    field: 'ten_tg_ts',
    headerName: 'Tên tăng giảm',
    width: 250
  }
];
